module.exports = __webpack_public_path__ + "static/shoe-brown-36945139b00401e511f4d9f921660f58.png";